// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"486":"20209124","659":"49950fdd","664":"bee978c2","874":"7608a82f","937":"788edb99"}[chunkId] + ".chunk.js";
};